<template>
  <!--    -->
  <el-dialog title="公告資料" :visible.sync="show">
    <el-form :model="form" :rules="rules" ref="addForm">
      <el-form-item prop="code" label="圖片編碼" :label-width="formLabelWidth">
        <el-input v-model="form.code" type="text"></el-input>
      </el-form-item>
      <el-form-item prop="link" label="連結網址" :label-width="formLabelWidth">
        <el-input v-model="form.link" type="text"></el-input>
      </el-form-item>
      <el-form-item prop="daterange" label="日期區間" :label-width="formLabelWidth">
        <el-date-picker
            :style="{width:'100%'}"
            v-model="form.daterange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close" :loading="loading">取 消</el-button>
      <el-button type="primary" @click="addAnnounce" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
  <!--   新增公告表單   -->
</template>

<script>
import {announceEdit} from "@/api";

export default {
  name: "AddAnnouncement",
  props: ['value'],
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    const validateDateRange = (rule, value, callback) => {
      if (value === null) {
        callback(new Error('请選擇日期區間'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      formLabelWidth: '100px',
      form: {
        code: '',
        link: '',
        daterange: null,
      },
      rules: {
        code: [
          {required: true, message: '請提供圖片編碼, 後續與圖片檔名作比對用', trigger: 'change'},
          {min: 3, message: '請輸入至少 3 個字母', trigger: 'change'}
        ],
        link: [
          {required: true, message: '请输入連結', trigger: 'change'},
          {min: 3, message: '請輸入至少 3 個字', trigger: 'change'}
        ],
        daterange: [
          {required: true, message: '请選擇起迄日期', trigger: 'change', validator: validateDateRange},
        ],
      },
    }
  },
  methods: {
    formatDate(date) {
      return date.toISOString().split('T')[0]
    },
    close() {
      this.$emit('input', false)
    },
    addAnnounce() {
      this.$refs['addForm'].validate(valid => {
        console.log(valid);
        if (valid) {
          this.loading = true
          this.close()
          announceEdit({
            AID: 0,
            CODE: this.form.code,
            LINK: this.form.link,
            SDATE: this.formatDate(this.form.daterange[0]),
            EDATE: this.formatDate(this.form.daterange[1])
          }).then(result => {
            this.loading = false
            this.form = {
              code: '',
              link: '',
              daterange: null
            }
            this.$message.success('公告新增成功')
          }).catch(reason => {
            this.loading = false
            this.$message.error(`公告新增失敗:${reason}`)
          })
        } else {
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
